import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=33d055d2&scoped=true"
import script from "./userList.vue?vue&type=script&lang=ts"
export * from "./userList.vue?vue&type=script&lang=ts"
import style0 from "./userList.vue?vue&type=style&index=0&id=33d055d2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d055d2",
  null
  
)

export default component.exports